import { render } from "./cpt-ring-pie-option.vue?vue&type=template&id=7c5c828d"
import script from "./cpt-ring-pie-option.vue?vue&type=script&lang=js"
export * from "./cpt-ring-pie-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__